import swup from "../entrypoints/swup";

export default () => ({
  isShop: false,
  belowTheFold: false,
  animate: false,
  selectedCategory: 'All',
  hoveredCategory: null as string | null,
  translateCategory: 'All',
  indicatorLeft: 0,
  indicatorWidth: 0,
  isLg: false,
  panelTransform: 0,
  resizeHandler: null as (() => void) | null,
  getCategoryIndex(category: string | null): number {
    if (!category) return 0;
    const button = this.$root.querySelector(`[data-category="${category}"]`) as HTMLElement;
    if (button) {
      const index = button.getAttribute('data-category-index');
      return index ? parseInt(index, 10) : 0;
    }
    return 0;
  },
  getActiveCategory(): string {
    return this.hoveredCategory || this.selectedCategory || 'All';
  },
  getTranslateCategory(): string {
    return this.hoveredCategory || this.selectedCategory || 'All';
  },
  init() {
    let i = this;

    function scroll() {
      if (window.scrollY > window.innerHeight - 60) {
        i.belowTheFold = true;
      } else {
        i.belowTheFold = false;
      }
    }

    scroll();

    swup.hooks.on("visit:start", () => {
      i.closeMenu();
    });

    swup.hooks.on("content:replace", () => {
      scroll();
    });

    window.addEventListener("scroll", () => {
      scroll();
    });

    setTimeout(() => {
      i.animate = true;
    }, 1600);

    this.$nextTick(() => {
      this.updateIndicator(this.selectedCategory);
    });

    this.isLg = window.innerWidth >= 1024;
    this.panelTransform = this.getCategoryIndex(this.selectedCategory) * 100;

    this.resizeHandler = () => {
      this.isLg = window.innerWidth >= 1024;
      if (this.isLg) {
        this.panelTransform = this.getCategoryIndex(this.selectedCategory) * 100;
      }
      if (this.isShop) {
        this.updateIndicator(this.selectedCategory);
      }
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  destroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
    }
  },
  toggleMenu() {
    if (this.isShop) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  },
  openMenu() {
    this.isShop = true;
    document.body.style.overflow = "hidden";
    this.$nextTick(() => {
      const firstButton = this.$root.querySelector('[data-category]') as HTMLElement;
      if (firstButton && !this.selectedCategory) {
        const firstCategory = firstButton.getAttribute('data-category');
        if (firstCategory) {
          this.selectedCategory = firstCategory;
          this.translateCategory = firstCategory;
        }
      } else {
        this.translateCategory = this.selectedCategory;
      }
      this.updateIndicator(this.selectedCategory);
      this.isLg = window.innerWidth >= 1024;
      if (this.isLg) {
        this.panelTransform = this.getCategoryIndex(this.selectedCategory) * 100;
      }
    });
  },
  closeMenu() {
    this.isShop = false;
    document.body.style.overflow = "auto";
  },
  selectCategory(category: string) {
    this.selectedCategory = category;
    this.translateCategory = category;
    this.updateIndicator(category);
    if (this.isLg) {
      this.panelTransform = this.getCategoryIndex(category) * 100;
    }
  },
  hoverCategory(category: string) {
    this.hoveredCategory = category;
    this.translateCategory = category;
    this.updateIndicator(category);
  },
  clearHover() {
    this.hoveredCategory = null;
    this.translateCategory = this.selectedCategory;
    this.updateIndicator(this.selectedCategory);
  },
  updateIndicator(category: string) {
    this.$nextTick(() => {
      const button = this.$root.querySelector(`[data-category="${category}"]`) as HTMLElement;
      if (button) {
        const container = button.parentElement as HTMLElement;
        if (container) {
          const containerRect = container.getBoundingClientRect();
          const buttonRect = button.getBoundingClientRect();
          this.indicatorLeft = buttonRect.left - containerRect.left;
          this.indicatorWidth = buttonRect.width;
        }
      }
    });
  },
});
